module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "container full"
  }, [_c('keep-alive', [_c('router-view', {
    tag: "component",
    attrs: {
      "aspect": _vm.aspect,
      "rect": _vm.rect,
      "renderer": _vm.renderer
    },
    on: {
      "glClick": function (v) {
        _vm.$emit('glClick', v)
      },
      "setMouse": function (v) {
        _vm.setMouse = v
      },
      "exec": function (v) {
        _vm.exec = v
      },
      "scene": function (v) {
        _vm.scene = v
      },
      "camera": function (v) {
        _vm.camera = v
      }
    }
  })], 1), _vm._v(" "), (_vm.keepRenderer) ? _c('WebGLRenderer', {
    attrs: {
      "rect": _vm.rect,
      "camera": _vm.camera,
      "scene": _vm.scene
    },
    on: {
      "renderer": function (v) {
        _vm.renderer = v
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7b2c8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebGL/GLView.vue
// module id = 578
// module chunks = 0